type Props = {
  html: string;
};

export function ContentSection({ html }: Props) {
  return <div class="content-section" dangerouslySetInnerHTML={{ __html: html }} />;
}
